export default {
	name: "indexView",
	data() {
		return {
			url: ''
		};
	},
	created() {
		this.url = JSON.parse(this.$route.query.url);
		console.log('playVideo url: ', this.url);
		this.$router.replace({
			name: 'videoPlay',
			params: {
				url: this.url
			}
		});

		document.addEventListener('keydown', e => {
			// 拦截F12键（键码123）
			if (e.keyCode === 123) {
				e.preventDefault();
				return false;
			}
			// 拦截Ctrl+Shift+I/C/J等组合键
			if (e.ctrlKey && (e.keyCode === 73 || e.keyCode === 74)) {
				e.preventDefault();
				return false;
			}
		});
	},
	async mounted() {

		const video = document.getElementById('playVideo');

		// 阻止视频元素右键菜单
		video.addEventListener('contextmenu', e => {
			e.preventDefault();
			return false;
		});

	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {},
};